export const GET_DATE_OF_FLIGHT = 'DATE_OF_FLIGHT';
export const GET_BOOKING = "BOOKING";
export const GET_BOOKING_FLIGHT_PRICE = "GET_BOOKING_FLIGHT_PRICE";
export const GET_FLEX_EXTRAS = "GET_FLEX_EXTRAS";
export const GET_BOOKING_TOTAL_PRICE = "BOOKING_TOTAL_PRICE";
export const GET_BOOKING_TRAVELLERS_TOTAL = "BOOKING_TRAVELLERS_TOTAL";
export const GET_BOOKING_DATE = "BOOKING_DATE";
export const GET_BOOKING_DISCOUNT_CODE = "BOOKING_DISCOUNT_CODE";
export const GET_BOOKING_TRAVELLERS_MERGED = "BOOKING_TRAVELLERS_MERGED";
export const GET_BOOKING_DISCOUNT_CODE_IS_APPLICABLE = "BOOKING_DISCOUNT_CODE_IS_APPLICABLE";
export const GET_BOOKING_DISCOUNT = "BOOKING_DISCOUNT";
export const GET_BOOKING_TOTAL_PRICE_WITHOUT_DISCOUNT = "BOOKING_TOTAL_PRICE_WITHOUT_DISCOUNT";
export const GET_RESERVATION = 'RESERVATION';
export const GET_TERMS = 'TERMS';
export const GET_BOOKING_DESTINATION_CITY_CODE = 'BOOKING_DESTINATION_CITY_CODE';
export const GET_AGGREGATE_EXTRA_PRICE = 'AGGREGATE_EXTRA_PRICE';
export const GET_DOCUMENT_NEED = 'GET_DOCUMENT_NEED';
export const GET_FLEX_EXTRA_SELECTED = 'GET_FLEX_EXTRA_SELECTED';
